import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: 'AIzaSyCxkg3XctcPXEE4OrSBB7f9Ic3ClVZwM9w',
  authDomain: 'gabylenautoservice.firebaseapp.com',
  projectId: 'gabylenautoservice',
  storageBucket: 'gabylenautoservice.firebasestorage.app',
  messagingSenderId: '5779942759',
  appId: '1:5779942759:web:ece2e4ec3da9f669d493c2',
  measurementId: 'G-LDBSLS9N5B',
};

// Initialize Firebase
export const firebaseApp = initializeApp(firebaseConfig);
// Export the Firebase Auth instance
export const firebaseAuth = getAuth(firebaseApp);
